import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertUpholsteryOptions } from './expert-upholstery.component';

@Directive({
  selector: '[upholsteryPlaceholderNullOnClick]'
})

export class UpholsteryPlaceholderNull {
   constructor(private _elementRef : ElementRef , private expUpholsteryOptions : ExpertUpholsteryOptions) {
    }

    @Output()
    public upholsteryPlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {               
            this.expUpholsteryOptions.expertUpholsteryOptions="";
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-upholstery/expert-upholstery-placeholder-null.ts